import { render, staticRenderFns } from "./userChangePasswordDialog.vue?vue&type=template&id=64a184f3&"
import script from "./userChangePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./userChangePasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports